module.exports = __webpack_public_path__ + "static/20943546-608dd94350fbda5db62a1d3ba929a003.jpg";